import * as i0 from '@angular/core';
import * as i1 from './tabs.module';
import * as i2 from '@angular/common';
import * as i3 from './tabs.component';
import * as i4 from './tab.component';
import * as i5 from './tab-title.directive';
import * as i6 from './tab-content.directive';
export const TabsModuleNgFactory:i0.NgModuleFactory<i1.TabsModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.TabsComponent = (<any>(null as any));
var _decl0_12:i4.TabComponent = (<any>(null as any));
var _decl0_13:i5.TabTitleDirective = (<any>(null as any));
var _decl0_14:i6.TabContentDirective = (<any>(null as any));
var _decl0_15:i2.AsyncPipe = (<any>(null as any));
var _decl0_16:i2.UpperCasePipe = (<any>(null as any));
var _decl0_17:i2.LowerCasePipe = (<any>(null as any));
var _decl0_18:i2.JsonPipe = (<any>(null as any));
var _decl0_19:i2.SlicePipe = (<any>(null as any));
var _decl0_20:i2.DecimalPipe = (<any>(null as any));
var _decl0_21:i2.PercentPipe = (<any>(null as any));
var _decl0_22:i2.TitleCasePipe = (<any>(null as any));
var _decl0_23:i2.CurrencyPipe = (<any>(null as any));
var _decl0_24:i2.DatePipe = (<any>(null as any));
var _decl0_25:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_26:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_27:i2.KeyValuePipe = (<any>(null as any));
var _decl0_28:i2.CommonModule = (<any>(null as any));
var _decl0_29:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_30:i0.ElementRef<any> = (<any>(null as any));
function _View_TabsComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_TabsComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = i0.ɵinlineInterpolate(2,'nav nav-',_decl0_11.type,' ',_decl0_11.cssClass,
      '');
  currVal_0;
  const currVal_1:any = (<any>{'nav-stacked':_decl0_11.vertical,'nav-justified':_decl0_11.justified});
  currVal_1;
  const currVal_2:any = _decl0_11.tabs;
  currVal_2;
  const currVal_3:any = _decl0_11.tabs;
  currVal_3;
}
function _View_TabComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_TabComponent_2_0():void {
  var _any:any = (null as any);
}
